import React from "react";

interface Props {
  isLoggedIn: boolean;
  isSuccess: boolean;
  isError: boolean;
  isLoading: boolean;
  isDrawerOpen: boolean;
  desktop: boolean;
  idRole: null | number;
  clientId: number | null;
  clientIds: number[];
  clients: { id: number; name: string }[];
  selectedClientId: number | null;
  setSelectedClientId: (clientId: number | null) => void;
  userName: string | null;
  userEmail: string | null;
  onMoveDrawer: (action: boolean) => void;
  onLogin: (username: string, password: string) => void;
  onLogout: () => void;
  validateToken: () => boolean;
  setToken?: (token: string) => void;
  setUser?: (user: any) => void;
  fetchUser?: (token: string) => void;
}

const AuthContext = React.createContext<Props>({
  isLoggedIn: false,
  isSuccess: false,
  isError: false,
  isLoading: false,
  isDrawerOpen: false,
  desktop: false,
  idRole: null,
  clientId: null,
  clientIds: [],
  clients: [],
  selectedClientId: null,
  setSelectedClientId: () => {},
  userName: null,
  userEmail: null,
  onMoveDrawer: () => {},
  onLogin: () => {},
  onLogout: () => {},
  validateToken: () => false,
  setToken: () => {},
  setUser: () => {},
  fetchUser: () => {},
});

export default AuthContext;
